(function() {
    const debounce = (fn, delay) => {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => fn.apply(this, args), delay);
        };
    };

    const isOverflowingHorizontally = (el) => {
        const rect = el.getBoundingClientRect();
        return rect.left < 0 || rect.right > window.innerWidth;
    };

    const initWishlistObserver = () => {
        const popup = document.querySelector(".msg-tooltip.wishlistError");
        if (!popup) return;
        const observer = new MutationObserver(() => {
            popup.style.display = popup.classList.contains("hulkActive") ? "block" : "none";
        });
        observer.observe(popup, { attributes: true, attributeFilter: ["class"] });
    };

    document.addEventListener('click', (e) => {
        if(typeof e.target.closest === 'undefined') return;
        const btn = e.target.closest('.product-grid .icon-wishlist-heart-empty, .cart-items .addtoWishlist, .product .icon-wishlist-heart-empty');
        if (btn) {
            const errorMessage = document.querySelector('.msg-tooltip');
            if (errorMessage) {
                const wrapperDiv = document.createElement('div');
                wrapperDiv.classList.add('hulkWishListOverlay');
                wrapperDiv.innerHTML = errorMessage.outerHTML;
                errorMessage.parentNode.replaceChild(wrapperDiv, errorMessage);
                setTimeout(() => {
                    if (wrapperDiv.parentNode) wrapperDiv.classList.remove('hulkWishListOverlay');
                }, 5000);
            }
        }
    });

    document.addEventListener('mouseenter', (e) => {
        if(typeof e.target.closest === 'undefined') return;
        const icon = e.target.closest(".icon-wishlist-heart-empty.wishlist-btn.grid-wishlist-btn");
        if (icon) {
            const count = icon.querySelector(".count.hulkapps-collection-count");
            if (!count) return;
            const match = count.textContent.match(/\d+/);
            const countNumber = match ? match[0] : "0";
            count.textContent = `이 상품은 ${countNumber}회 위시리스트에 추가되었습니다.`;
            count.style.setProperty("display", "block", "important");
            if (isOverflowingHorizontally(count)) {
                count.classList.toggle("count-change-side");
            }
        }
    }, true);

    document.addEventListener('mouseleave', (e) => {
        if(typeof e.target.closest === 'undefined') return;
        const icon = e.target.closest(".icon-wishlist-heart-empty.wishlist-btn.grid-wishlist-btn");
        if (icon) {
            const count = icon.querySelector(".count.hulkapps-collection-count");
            if (count) count.style.setProperty("display", "none", "important");
        }
    }, true);

    function moveWishlistIcons() {
        document.querySelectorAll('.grid__item .card-wrapper:not(.wl-moved)').forEach(function(card) {
            var wlIcon = card.querySelector('.card__heading.h5 a.icon-wishlist-heart-empty');
            var heading = card.querySelector('.card__heading.h5');
            if (!wlIcon || !heading) return;
            heading.insertAdjacentElement('afterend', wlIcon);
            card.classList.add('wl-moved');
        });
    }

// 로그인 모달 오픈 시 스크롤 잠금(메인 배너 버튼 간격) 시작
    let scrollPosition = 0;
    const targetModalId = 'login-dialog';
    // 스크롤 잠금 함수
    const lockScroll = () => {
        if (document.body.style.position === 'fixed') return;
        scrollPosition = window.pageYOffset;
        document.body.style.cssText = `position: fixed; top: -${scrollPosition}px; width: 100%; overflow-y: scroll;`;
    };
    // 스크롤 해제 함수
    const unlockScroll = () => {
        if (document.body.style.position !== 'fixed') return;
        const savedTop = document.body.style.top;
        document.body.style.cssText = '';
        window.scrollTo(0, parseInt(savedTop || '0') * -1);
    };

    //UI Updates
    const iconPaths = {
        pcFilter: `<path d="M15.5387 3.87203C15.7014 3.70933 15.9652 3.70933 16.1279 3.87203C16.2906 4.03476 16.2906 4.29853 16.1279 4.46123L10.5892 9.99997L16.1279 15.5387C16.2906 15.7014 16.2906 15.9652 16.1279 16.1279C15.9652 16.2906 15.7014 16.2906 15.5387 16.1279L10 10.5891L4.46124 16.1279C4.29852 16.2906 4.03476 16.2906 3.87204 16.1279C3.70933 15.9652 3.70934 15.7014 3.87204 15.5387L9.41075 9.99997L3.87204 4.46123C3.70932 4.29851 3.70932 4.03476 3.87204 3.87203C4.03476 3.70933 4.29852 3.70932 4.46124 3.87203L10 9.4108L15.5387 3.87203Z" fill="#171719"/>`,
        moFilter: `<path d="M5.94434 13C6.22048 13 6.44434 13.2239 6.44434 13.5V15H21.5C21.7761 15 22 15.2239 22 15.5C22 15.7761 21.7761 16 21.5 16H6.44434V17.5C6.44434 17.7761 6.22048 18 5.94434 18C5.66819 18 5.44434 17.7761 5.44434 17.5V16H2.5C2.22386 16 2 15.7761 2 15.5C2 15.2239 2.22386 15 2.5 15H5.44434V13.5C5.44434 13.2239 5.66819 13 5.94434 13ZM18.0557 6C18.3318 6 18.5557 6.22386 18.5557 6.5V8H21.5C21.7761 8 22 8.22386 22 8.5C22 8.77614 21.7761 9 21.5 9H18.5557V10.5C18.5557 10.7761 18.3318 11 18.0557 11C17.7795 11 17.5557 10.7761 17.5557 10.5V9H2.5C2.22386 9 2 8.77614 2 8.5C2 8.22386 2.22386 8 2.5 8H17.5557V6.5C17.5557 6.22386 17.7795 6 18.0557 6Z" fill="#171719"/>`,
        caret: `<path fill-rule="evenodd" clip-rule="evenodd" d="M15.7006 7.62972C15.8758 7.80267 15.8758 8.08308 15.7006 8.25604L10.9505 12.9442C10.4249 13.4631 9.57253 13.4631 9.04678 12.9442L4.29678 8.25604C4.12153 8.08308 4.12153 7.80267 4.29678 8.25604C4.47203 7.45676 4.75612 7.45676 4.93137 7.62972L9.68136 12.3178C9.85661 12.4908 10.1408 12.4908 10.3159 12.3178L15.066 7.62972C15.2413 7.45676 15.5254 7.45676 15.7006 7.62972Z" fill="#171719"/>`,
        plus: `<path d="M10.0155 4.16406C10.1765 4.16414 10.3072 4.2947 10.3072 4.45573V9.6915H15.543C15.704 9.6915 15.8346 9.82216 15.8346 9.98316C15.8346 10.1442 15.704 10.2748 15.543 10.2748H10.3072V15.5391C10.3072 15.7001 10.1765 15.8307 10.0155 15.8307C9.85448 15.8307 9.72387 15.7001 9.72387 15.5391V10.2748H4.45964C4.29855 10.2748 4.16797 10.1442 4.16797 9.98316C4.16805 9.82216 4.29861 9.6915 4.45964 9.6915H9.72387V4.45573C9.72387 4.29465 9.85448 4.16406 10.0155 4.16406Z" fill="#09090B"/>`,
        minus: `<path fill-rule="evenodd" clip-rule="evenodd" d="M4.16797 10.2917C4.16797 10.1306 4.29855 10 4.45964 10H15.543C15.704 10 15.8346 10.1306 15.8346 10.2917C15.8346 10.4527 15.704 10.5833 15.543 10.5833H4.45964C4.29855 10.5833 4.16797 10.4527 4.16797 10.2917Z" fill="#09090B"/>`,
        checkboxBase: `<rect x="0.5" y="0.5" width="19" height="19" rx="1.5" fill="white"/><rect x="0.5" y="0.5" width="19" height="19" rx="1.5" stroke="#09090B"/>`,
        checkmark: `<path fill-rule="evenodd" clip-rule="evenodd" d="M13.0962 0.12912C13.2683 0.30128 13.2683 0.580407 13.0962 0.752567L4.90275 8.946C4.38628 9.46247 3.5489 9.46247 3.03242 8.946L0.12912 6.04267C-0.04304 5.87053 -0.04304 5.5914 0.12912 5.4192C0.30128 5.24707 0.580407 5.24707 0.752567 5.4192L3.65587 8.32253C3.82803 8.49467 4.10715 8.49467 4.27931 8.32253L12.4727 0.12912C12.6449 -0.04304 12.924 -0.04304 13.0962 0.12912Z" fill="black"/>`,
        close: `<path d="M15.3105 4.25399C15.4304 4.13409 15.6247 4.13409 15.7445 4.25399C15.8644 4.37388 15.8644 4.56818 15.7445 4.68807L10.4353 9.99731L15.7445 15.3066C15.8644 15.4265 15.8644 15.6208 15.7445 15.7406C15.6247 15.8605 15.4304 15.8605 15.3105 15.7406L10.0012 10.4314L4.69197 15.7406C4.57208 15.8605 4.37779 15.8605 4.25789 15.7406C4.13799 15.6208 4.13799 15.4265 4.25789 15.3066L9.56716 9.99731L4.25789 4.68807C4.13799 4.56817 4.13799 4.37388 4.25789 4.25399C4.37779 4.13411 4.57208 4.13409 4.69197 4.25399L10.0012 9.56325L15.3105 4.25399Z" fill="#171719"/>`
    };

    //PLP 가격 앞에 ₩ 심볼 감싸기 시작
    const wrapCurrencySymbolForPLP = () => {
        if (!window.location.pathname.includes('/collections/')) return;
        const priceElements = document.querySelectorAll('.price-item:not(.symbol-wrapped)');
        priceElements.forEach((el) => {
            if (el.querySelector('.currency-symbol')) {
                el.classList.add('symbol-wrapped');
                return;
            }
            const text = el.textContent.trim();
            if (text.includes('₩')) {
                el.innerHTML = text.replace('₩', '<span class="currency-symbol">₩</span>');
                el.classList.add('symbol-wrapped');
            }
        });
    };

    const formatCount = () => {
        ['ProductCountDesktop', 'ProductCount'].forEach(id => {
            const el = document.getElementById(id);
            if (el && el.innerText.includes('/')) {
                const newText = el.innerText.split('/').pop().trim();
                if (el.innerText !== newText) el.innerText = newText;
            }
        });
    };

    const replaceFilterIcons = () => {
        const replaceSvg = (selector, viewBox, innerHTML, size) => {
            document.querySelectorAll(selector + ':not(.icon-replaced)').forEach(svg => {
                svg.setAttribute('viewBox', viewBox);
                if (size) {
                    svg.setAttribute('width', size);
                    svg.setAttribute('height', size);
                }
                svg.innerHTML = innerHTML;
                svg.classList.add('icon-replaced');
            });
        };
        replaceSvg('.active-facets__button-inner svg', '0 0 20 20', iconPaths.pcFilter);
        replaceSvg('.mobile-facets__open .icon-refine-sort', '0 0 24 24', iconPaths.moFilter, '20');
        replaceSvg('.select .icon-caret', '0 0 20 20', iconPaths.caret);
        replaceSvg('.icon-plus', '0 0 20 20', iconPaths.plus);
        replaceSvg('.icon-minus', '0 0 20 20', iconPaths.minus);
        replaceSvg('.mobile-facets__checkbox + svg', '0 0 20 20', iconPaths.checkboxBase);
        replaceSvg('.icon-checkmark', '0 0 14 10', iconPaths.checkmark);

        const label = document.querySelector('.mobile-facets__open-label');
        if (label && label.innerText.trim() === '필터') {
            label.innerText = '필터/정렬기준';
        }
    };

    const replaceText = () => {
        document.querySelectorAll('.mobile-facets__clear').forEach(button => {
            if (button.innerText.trim() === '모두 지우기') button.innerText = 'Clear All';
        });
        document.querySelectorAll('.button--primary, .no-js-hidden.button').forEach(button => {
            if (button.innerText.trim() === '적용') button.innerText = 'Apply';
        });
    };

    const customizeMobileHeader = () => {
        const headerInner = document.querySelector('.mobile-facets__header-inner');
        if (!headerInner || headerInner.querySelector('.custom-header-left')) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'custom-header-wrapper';
        wrapper.style.cssText = 'display: flex; justify-content: space-between; align-items: center; width: 100%;';
        wrapper.innerHTML = `
            <div class="custom-header-left" style="display: flex; align-items: center; gap: 8px;">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">${iconPaths.moFilter}</svg>
                <span class="custom-header-title" style="font-size: 14px; font-weight: 700;">필터/정렬기준</span>
            </div>
            <div class="custom-new-close" style="cursor: pointer; display: flex; align-items: center;">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">${iconPaths.close}</svg>
            </div>
        `;
        wrapper.querySelector('.custom-new-close').addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const mainDetails = document.querySelector('menu-drawer details[open], .mobile-facets__wrapper details[open]');
            if (mainDetails) mainDetails.querySelector('summary').click();
        });
        headerInner.prepend(wrapper);
    };

    const insertSidebarImage = () => {
        const container = document.querySelector('.facets-vertical .facets-wrapper .facets-container .facets.small-hide');
        if (!container || container.querySelector('.custom-sidebar-img')) return;

        const handle = (window.__collectionHandle || '').toLowerCase();
        const isTees = handle.includes('티셔츠');
        const isMens = handle.includes('남성');

        const newLink = document.createElement('a');
        newLink.className = 'custom-sidebar-link';
        newLink.style.cssText = `display: block; width: 100%; margin-bottom: 20px; margin-top: 7px; text-decoration: none;`;

        let imgSrc = 'https://cdn.shopify.com/s/files/1/0669/3640/6169/files/jeans-guide.png?v=1770115468';
        if (isTees) {
            newLink.href = '/collections/2508teeguide';
            imgSrc = 'https://cdn.shopify.com/s/files/1/0669/3640/6169/files/tee-guide.png?v=1770172001';
        } else if (isMens) {
            newLink.href = '/pages/levis_501_fit_guide';
        } else {
            newLink.href = '/pages/womens-fit-guide';
        }

        newLink.innerHTML = `<img src="${imgSrc}" class="custom-sidebar-img" style="width: 100%; height: auto; display: block;">`;
        container.prepend(newLink);
    };

    const runUpdates = () => {
        formatCount();
        replaceFilterIcons();
        replaceText();
        customizeMobileHeader();
        insertSidebarImage();
        wrapCurrencySymbolForPLP();
        moveWishlistIcons();
    };

    // Main debounced observer for DOM changes
    const mainObserver = new MutationObserver(debounce((mutations) => {
        runUpdates();
        
        // Modal check (only if attributes changed)
        const modal = document.getElementById(targetModalId);
        if (modal) {
            const isVisible = window.getComputedStyle(modal).display !== 'none' || modal.classList.contains('active');
            isVisible ? lockScroll() : unlockScroll();
        }
    }, 150));

    mainObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });

    // Initial Execution
    const init = () => {
        initWishlistObserver();
        runUpdates();
        const modalElement = document.getElementById(targetModalId);
        if (modalElement) {
            const isVisible = window.getComputedStyle(modalElement).display !== 'none' || modalElement.classList.contains('active');
            if (isVisible) lockScroll();
        }
    };

    init();
})();
